import { Navigate, Outlet } from "react-router-dom";

const Private = () => {
  const data = localStorage.getItem("role");
  return data ? <Outlet /> : <Navigate to="/" />;
};

export default Private;
